import { Box, Button, Typography, Modal } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useHistory } from "react-router-dom";

const OutOfStockModal = ({ openWarningModal, setOpenWarningModal }) => {
  const history = useHistory();

  return (
    <Modal open={openWarningModal} onClose={() => setOpenWarningModal(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
          outline: "none",
          textAlign: "center",
        }}
      >
        <WarningAmberRoundedIcon
          sx={{ fontSize: 60, color: "warning.main", mb: 2 }}
        />

        <Typography variant="h6" fontWeight="bold" mb={1}>
          موجودی حساب شما کافی نیست
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          برای ادامه ثبت سفارش، لطفاً حساب خود را شارژ نمایید. می‌توانید از طریق
          دکمه زیر وارد درگاه بانکی شده و مبلغ مورد نظر را واریز کنید.
        </Typography>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            fullWidth
            variant="outlined"
            color="inherit"
            onClick={() => setOpenWarningModal(false)}
          >
            انصراف
          </Button>

          <Button
            fullWidth
            variant="contained"
            color="warning"
            onClick={() => {
              history.push("/deposit");
            }}
          >
            رفتن به پنل پرداخت
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OutOfStockModal;
